import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import { initThree, scene, camera, renderer, incRenderCount, createFloor, grid } from './initThree';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Box from 'vux/src/components/box/index.vue'

import loading from '@/components/loading';
import { VoroStandMaker } from "./VoroStandMaker.js";


let voromaker = new VoroStandMaker();
voromaker.nParticles = 100;
voromaker.stickRadius = 1;
voromaker.scale = 30;

export default {
name: "makeVoroStand",
mixins: [printModel],
components: {
XDialog,
range: Range, radio: Radio, Group, Cell, loading, Checker, CheckerItem, XSwitch, XProgress, Box
},
data() {
return {
quotationName: "Voronoi摆件",
productType: "Voronoi摆件",
landscape: true,//竖屏状态要一直为true
showLoading: false,
showPrint: false,
showShape: false,
showAttribute: false,
showVoroWork: false,
isShapeItemIndex: 0,
addCartIndex: -1,
orderIndex: -1,
isVoroBtnIndex: -1,
btnsList: [
{
isClick: false,
icon: require("../imgs/形状.png"),
iconClick: require("../imgs/形状.png"),
title: "形状",
},
{
isClick: false,
icon: require("../imgs/属性.png"),
iconClick: require("../imgs/属性.png"),
title: "属性",
},
{
isClick: false,
icon: require("../imgs/作品.png"),
iconClick: require("../imgs/作品.png"),
title: "作品",
},
],
shapeItemList: [
{
content: "正四面体",
},
{
content: "立方体",
},
{
content: "正八面体",
},
{
content: "正十二面体",
},
{
content: "正二十面体",
}
],
shapeList: voromaker.shapeList,
draw: {
nParticles: voromaker.nParticles,//粒子数量
stickRadius: voromaker.stickRadius,//粒子半径
scale: voromaker.scale,//粒子缩放
}
}
},
mounted() {
const scope = this;
scope.showLoading = true;

var mo = function (e) {
e.preventDefault();
}

initThree(scope.$refs.canvas);
scope.floor = createFloor();



const contentDOM = scope.$refs.makeVoroStand;


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);


scope.$nextTick(function () {
scope.$refs.makeVoroStand.style.paddingTop = '0px';
scope.$refs.makeVoroStand.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});

voromaker.makeMesh(scene);
scope.updateParticles().then(() => {
voromaker.makeModelForDisplay();
incRenderCount();
});

setTimeout(function () {
scope.showVoroWork = true;
scope.showLoading = false;
scope.touchstart();
}, 100);

scope.$nextTick(function () {
scope.loadData();
});
},
watch: {
"draw.stickRadius": function () {//粒子半径
voromaker.stickRadius = this.draw.stickRadius;
voromaker.updateSizeOrStickRadius();
incRenderCount();
},
"draw.scale": function () {//粒子缩放
voromaker.scale = this.draw.scale;
voromaker.updateSizeOrStickRadius();
this.gridChange(voromaker.shapeIndex);
incRenderCount();
},
},
methods: {
updateParticles() {
const shape = this.shapeList[voromaker.shapeIndex];
return this.$request.post(shape.url, {
n_particles: voromaker.nParticles,
type: shape.type,
}).then((res) => {
if (res.code == 0) {
voromaker.particles = res.obj;
let particles = [];
for (let i = 0; i < voromaker.particles.vertices.length; i += 3) {
let v = new THREE.Vector3(voromaker.particles.vertices[i], voromaker.particles.vertices[i + 1], voromaker.particles.vertices[i + 2]);
v.multiplyScalar(shape.scale);
particles.push(v);
}
voromaker.particlePositions = particles;
}
});
},

gridChange(shapeIndex) {
shapeIndex += "";
let obj = {
"0": 1.09,
"1": 1.06,
"2": 1.06,
"3": 1.06,
"4": 0.95,
}
grid.position.y = - voromaker.scale * obj[shapeIndex];
},

touchend() {
voromaker.nParticles = this.draw.nParticles;
this.showLoading = true;
this.updateParticles().then(() => {
voromaker.makeModelForDisplay();
incRenderCount();
this.showLoading = false;
});
},


refresh() {
this.showLoading = true;
this.updateParticles().then(() => {
voromaker.makeModelForDisplay();
incRenderCount();
this.showLoading = false;
});
},


seleShapeItem(index) {
const scope = this;
scope.isShapeItemIndex = index;
voromaker.shapeIndex = scope.isShapeItemIndex;
scope.gridChange(voromaker.shapeIndex);
scope.showLoading = true;
scope.showShape = false;
scope.updateParticles().then(() => {
voromaker.makeModelForDisplay();
incRenderCount();
scope.showLoading = false;
scope.isVoroBtnIndex = -1;
});
},


loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("voroStand");
localStorage.removeItem("voroStand"); 
if (dataStr) {
let data = JSON.parse(dataStr);
scope.draw.scale = data.scale;
scope.draw.nParticles = data.nParticles;
scope.draw.stickRadius = data.stickRadius;
}
}
},


saveData() {
const scope = this;
if (window.localStorage) {
let data = {};
data.scale = scope.draw.scale;
data.nParticles = scope.draw.nParticles;
data.stickRadius = scope.draw.stickRadius;
localStorage.setItem("voroStand", JSON.stringify(data));
}
},

handler(index) {
this.isVoroBtnIndex = index;
if (index === 0) {//形状
this.optimizedPopClick();
this.showShape = true;
this.btnsList[0].isClick = true;
return;
} else if (index === 1) {//属性
this.optimizedPopClick();
this.showAttribute = true;
this.btnsList[1].isClick = true;
return;
} else if (index === 2) {//作品
this.optimizedPopClick();
this.showVoroWork = true;
this.btnsList[2].isClick = true;
return;
}
},

optimizedPopClick() {
this.showPrint = false;
this.showShape = false;
this.showAttribute = false;
this.showVoroWork = false;
},


touchstart() {
this.optimizedPopClick();
this.isVoroBtnIndex = -1;
},


downloads() {
const scope = this;
scope.showLoading = true;

if (voromaker.mesh) {

if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
scope.$request.post('/SmallSoftware/requestDownload', {
type: "voro",
}).then(function (res) {
if (res.obj === true) {
scope.downloadModels("voroStand", voromaker.makeModel(), "Voronoi四面体");
setTimeout(() => {
scope.$vux.toast.show({
text: '下载成功',
type: "success",
time: 2000,
position: "middle",
});
scope.showLoading = false;
}, 50);
} else {
scope.$vux.toast.show({
text: '下载失败',
type: "warn",
time: 2000,
position: "middle",
});
}
});
}
}
},

downloadModels(type, mesh, filename) {
let exporter = new THREE.STLExporter();
let result = exporter.parse(mesh, {
binary: true
});
let blob = new Blob([result], {
type: 'application/octet-stream'
});
filename += ".stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},

getModelToPrint() {
return voromaker.makeModel();
},

makeStlBlob() {
if (this.choiceStyle == 0 && this.isReliefIndex != -1) {
return voromaker.exportBlob();
} else {
let exporter = new THREE.STLExporter();
let group = voromaker.mesh;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
}
},


print() {
this.showLoading = true;



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;
}

if (voromaker.mesh) {
this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
});

setTimeout(() => {
this.showLoading = false;
}, 50);
} else {
this.$vux.toast.show({
text: '3D模型不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.noUpdateMesh = false;
incRenderCount();

setTimeout(() => {
this.showLoading = false;
}, 50);
}
},
},
}



// WEBPACK FOOTER //
// ./src/views/makeVoroStand/scripts/voroStand.js